
define('text!templates/modules/feedback/blocks/comment.html',[],function () { return '<div id="feedback-comment"></div>\n';});

